import { Box, Radio, TextField, IconButton } from "@mui/material";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import { useEffect, useState } from "react";
import { emailRegex } from "../../utils/Constant";

type props = {
  name?: string;
  index?: number;
  selectedValue: string;
  emails?: any[];
  onRadioChange?: any;
  onDelete?: any;
  altEmail?: any;
  onEmailChange?: any;
  isEmailEmptyError?: boolean;
};

export default function AlternativeEmailField({
  name,
  index,
  selectedValue,
  emails,
  onRadioChange,
  altEmail,
  onEmailChange,
  onDelete,
  isEmailEmptyError,
}: props) {
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    // on form submit check if alt email is empty, if yes show error
    if (isEmailEmptyError && !altEmail) {
      setError(true);
      setErrorMessage("This field can't be empty");
    }
  }, [isEmailEmptyError]); // eslint-disable-line

  const handleEmailChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onEmailChange(event);
    const email = event?.target?.value;
    if (!email || !checkEmailValid(email) || isEmailDuplicate(email)) {
      setError(true);
      if (!email) {
        setErrorMessage("This field can't be empty");
      }
    } else {
      setError(false);
      setErrorMessage("");
    }
  };

  const checkEmailValid = (email: string) => {
    const isEmailValid = emailRegex.test(email);
    if (!isEmailValid) {
      setErrorMessage("Invalid Email Address");
    }
    return isEmailValid;
  };

  const isEmailDuplicate = (email: string) => {
    let isDuplicate = false;
    const allEmails = emails?.slice(0, -1);
    allEmails?.forEach((emailObj) => {
      if (email === emailObj.emailAddress) {
        isDuplicate = true;
      }
    });
    if (isDuplicate) {
      setErrorMessage("Duplicate email not allowed.");
    }
    return isDuplicate;
  };

  return (
    <Box sx={{ display: "flex", alignItems: "center", mt: 2 }}>
      <Radio
        id={`alt-email${index}`}
        sx={{ mr: 2 }}
        checked={selectedValue === `altEmail${index}`}
        onChange={onRadioChange}
        value={`altEmail${index}`}
        name="radio-buttons"
        inputProps={{ "aria-label": `Alternate Email ${index}` }}
      />
      <TextField
        id="alt-email"
        sx={{ width: "100%" }}
        label="Email"
        variant="outlined"
        name={name}
        value={altEmail}
        onChange={handleEmailChange}
        error={error}
        helperText={error && errorMessage}
      />
      {selectedValue !== `altEmail${index}` ? (
        <IconButton aria-label="delete" onClick={onDelete}>
          <DeleteOutlineOutlinedIcon style={{ color: "#D32F2F" }} />
        </IconButton>
      ) : (
        <Box sx={{ width: 46 }}></Box>
      )}
    </Box>
  );
}
